import { InternalAxiosRequestConfig } from "axios";
import { GLOBAL_KEYS } from "@/configs";

type CustomConfig = InternalAxiosRequestConfig;

export const api_map = {
  global: {
    development: "https://api-dev.amazwear.com",
    test: "https://api-test.amazwear.com",
    production: "https://api.amazwear.com",
    pre: "https://api-pre.amazwear.com",
  },
  hk: {
    development: "https://api-dev.amazwear.com",
    test: "https://api-test.amazwear.com",
    production: "https://api-hk.amazwear.com",
  },
  cn: {
    development: "https://api-dev.apexmove.com",
    test: "https://api-test.apexmove.com",
    production: "https://api.apexmove.com",
  },
};

export type ApiLocation = keyof typeof api_map;
export type ApiEnv = keyof (typeof api_map)[ApiLocation];

/**
 * 替换请求的api路径
 * @param config 请求配置
 * @returns 替换后的请求配置
 */
export const exchangeRequestApiConfig = (config: CustomConfig) => {
  if (process.env.APEX_LOCAL) {
    return config;
  }
  const { params, url } = config;
  const { __api_location, ...rest } = params || {};
  // 环境变量配置的接口节点
  const processLocation = process.env.API_LOCATION as ApiLocation;
  // localStorage中设置的接口节点
  const storageLocation = localStorage.getItem(GLOBAL_KEYS.API_LOCATION) as ApiLocation;
  // 请求参数中的接口节点
  const requestLocation = params?.__api_location as ApiLocation;
  // 优先级：请求参数中的接口节点 > localStorage中设置的接口节点 > 环境变量配置的接口节点 > global
  const realLocation = requestLocation ?? storageLocation ?? processLocation ?? "global";
  const apiConfig = api_map[realLocation];
  const newUrl = url?.replace(/^\/api/, apiConfig[(process.env.AMAZEMOVE_ENV as ApiEnv) || "development"]);
  return {
    ...config,
    url: newUrl,
    params: rest,
  };
};
